export const ALL_ROLES_API = '/api/roles';

export const USER_ROLES_BASE_API = '/api/users';
